module.exports = __webpack_public_path__ + "img/moneda.ed49b269.svg";